import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, CheckCircle, ArrowLeft } from 'lucide-react';
import Button from '../components/ui/Button';

const EmailVerification: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-sm rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
              <CheckCircle className="h-10 w-10 text-green-600" />
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Din konto er nu oprettet
            </h2>
            
            <div className="mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
                <Mail className="h-8 w-8 text-blue-600" />
              </div>
              
              <p className="text-base text-gray-700 mb-2">
                Du skal bekræfte din e-mail før du kan komme i gang.
              </p>
              
              <p className="text-sm text-gray-600">
                Vi har sendt en bekræftelsesmail til din e-mailadresse. 
                Tjek din indbakke og klik på linket i mailen for at aktivere din konto.
              </p>
            </div>

            <div className="space-y-4">
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-xs text-gray-600 mb-2">
                  <strong>Har du ikke modtaget en mail?</strong>
                </p>
                <ul className="text-xs text-gray-600 text-left space-y-1">
                  <li>• Tjek din spam/uønsket mail mappe</li>
                  <li>• Kontroller at e-mailadressen er korrekt</li>
                  <li>• Vent et par minutter - det kan tage lidt tid</li>
                </ul>
              </div>

              <div className="pt-4">
                <Button 
                  variant="outline" 
                  fullWidth 
                  icon={<ArrowLeft className="h-4 w-4 mr-2" />}
                  onClick={() => navigate(-1)}
                >
                  Tilbage til forsiden
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Har du problemer?{' '}
            <Link to="/contact" className="font-medium text-green-600 hover:text-green-500">
              Kontakt os
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
